import React, {useEffect, useState} from 'react';
import Slider from 'react-slick/lib';
import { ANIMATION_SPEED } from '../../globalUtils';
import {
    GrayContainer, Area, Title, RedStripe, Arrow, SliderContainer, CTA, CTAButton
} from './index.style';
import {PostSlide} from "./PostSlide";
import apiFetch from "@wordpress/api-fetch";
const { REACT_APP_BLOG_API_URL: blogApiUrl } = process.env;

apiFetch.use( apiFetch.createRootURLMiddleware( blogApiUrl ) );

const NextArrow = ({ className, onClick }) => {
    return (
        <Arrow
            className={className}
            onClick={onClick}
            style={{ transform: 'rotate(180deg)' }}
        >></Arrow>
    );
}
const PrevArrow = ({ className, onClick }) => {
    return (
        <Arrow
            className={className}
            onClick={onClick}
            style={{ transform: 'rotate(0deg)' }}
        >{'<'}</Arrow>
    );
}

const getImageUrl = (input) => {
    try {
        let regex = /<meta(.*(og:image))[\s\S]*?\/>/g;

        const images = input.match(regex);

        const image = images[0].match(/content(.*)$/gm);
        return image[0].split('"')[1];
    } catch {
        return 'https://yeda.marvihim.co.il/wp-content/uploads/2020/12/marvihim-logo.png';
    }
}

const fixUnicodeText = (string) => {
    return string.replace('&#8211;','-');
}

const BlogSlider = () => {
    const [postsData,setPostsData] = useState([]);

    useEffect(() => {
        async function getPostsData() {
            const posts = await apiFetch( { path: `/wp-json/wp/v2/posts?per_page=9&orderby=date` } );
            setPostsData(posts);
        }
        getPostsData();
    }, []);

    const items = postsData.map(function(item, index){
            if(item.status === 'publish') {
                return <PostSlide key={index}
                             image={getImageUrl(item.yoast_head)}
                             category={item.categories[0]}
                             date={item.date}
                             title={fixUnicodeText(item.title.rendered)}
                             description={item.excerpt.rendered}
                             link={item.link}
                             type="slider"
                />
            }
            return item;
        });
    const settings = {
        infinite: true,
        speed: ANIMATION_SPEED,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    };
    return <GrayContainer>
        <Area>
            <Title>
                <RedStripe />
                ממרכז הידע של מרוויחים
            </Title>
            <SliderContainer>
                <Slider {...settings}>{items}</Slider>
            </SliderContainer>

            <CTA>
                <CTAButton target="_blank" href={blogApiUrl}>למרכז הידע שלנו</CTAButton>
            </CTA>
        </Area>
    </GrayContainer>;
};

export default BlogSlider;
